import "../style/HoldOrder.css";

const HoldOrder = ({
  showHoldConfirm,
  setShowHoldConfirm,
  holdOrders = [],
  holdingOrder,
  handleConfirmHoldOrder,
}) => {
  if (!showHoldConfirm) return null;

  return (
    <div
      className="hold-confirm-overlay"
      onClick={() => {
        if (!holdingOrder) {
          setShowHoldConfirm(false);
        }
      }}
    >
      <div
        className="hold-confirm-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="hold-confirm-header">
          <h5> Hold Order </h5>
          <div className="hold-confirm-footer">
          <button
            type="button"
            className="btn btn-secondary"
            disabled={holdingOrder}
            onClick={() => setShowHoldConfirm(false)}
          >
            No
          </button>

          <button
            type="button"
            className="btn btn-primary"
            disabled={holdingOrder}
            onClick={handleConfirmHoldOrder}
          >
            {holdingOrder ? (
              <>
                <span
                  className="hold-spinner"
                  aria-hidden="true"
                />
                Holding...
              </>
            ) : (
              "Yes"
            )}
          </button>
        </div>

          <button
            type="button"
            className="hold-close-btn"
            disabled={holdingOrder}
            onClick={() => setShowHoldConfirm(false)}
          >
           <i className="bi bi-x"></i>
          </button>
        </div>

        {/* Body */}
        <div className="hold-confirm-body">
          {holdOrders.length > 0 ? (
            <>
              <div className="alert alert-warning">
                <strong>{holdOrders.length}</strong>{" "}
                hold order
                {holdOrders.length > 1 ? "s are" : " is"} already
                available.
              </div>

              <p className="hold-question">
                Do you want to hold the current order?
              </p>

              <div className="hold-order-list">
                {holdOrders.map((order, index) => {
                  const customer =
                    order?.cart_customers || {};

                  const summary =
                    order?.cart_summary || {};

                  return (
                    <div
                      className="hold-order-item"
                      key={
                        order?.cart_temp_token || index
                      }
                    >
                      <div className="hold-customer">
                        <strong>
                          {customer?.customer_name ||
                            "Customer"}
                        </strong>
                      </div>

                      <div className="hold-order-info">
                        <span>
                          <strong>Token:</strong>{" "}
                          {order?.cart_temp_token || "-"}
                        </span>

                        <span>
                          <strong>Qty:</strong>{" "}
                          {summary?.total_quantity || 0}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <p className="hold-question">
              Are you sure you want to hold this current order?
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default HoldOrder;
